import axios from "axios";
const userId =sessionStorage.getItem("userId")
export interface Department {
  DepartmentId: number;
  DepartmentName: string;
  Status: "A" | "I"; 
  CreatedBy: number;
  CreatedOn: string;
}

export interface Specialization {
  SpecializationId: number;
  DepartmentId: number;
  SpecializationName: string;
  Description: string | null;
  SpecializationIcon: string | null;
  Status: "A" | "I";
  CreatedBy: number;
  CreatedOn: string; 
}
export const getLocationAPI = async () => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Lookup/locations`,
    {
      params:{
 Remark:"Get the list of the locations", 
UserId:userId, 
 Event:"Get Locations"
      }
    }
  );
};


export const getDesignationAPI = async () => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Lookup/designations`,
     {
      params:{
 Remark:"Get the list of the designations", 
UserId:userId, 

 Event:"Get Designations"
      }
    }
  );
};
export const getDepartmentAPI = async () => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Lookup/departments`,
     {
      params:{
      Remark:"Get the list of the departments", 
      UserId:userId, 
      Event:"Get Departments"
      }
    }
  );
};
export const getSpecializationAPI = async ( DeptId:number) => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Lookup/specialization`,
     {
      params:{
         DeptId,
 Remark:"Get the list of the specialization", 
UserId:userId, 

 Event:"Get Specialization"
      }
    }
  );
};

export const getLanguageAPI = async () => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Lookup/languages`,
     {
      params:{
 Remark:"Get the list of the Languages", 
UserId:userId, 

 Event:"Get Languages"
      }
    }
  );
};

export const getTitleAPI = async () => {
  return axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/Lookup/title`,
      {
      params:{
 Remark:"Get the list of the Title", 
UserId:userId, 

 Event:"Get Titles"
      }
    }
  );
};